import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export const basePropertiesInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

  let headers = request.headers.append('x-client-id', environment.clientId);

  const isTranslationsRequest = /^assets\/i18n\/(pt\.json|en\.json)$/;

  if (isTranslationsRequest.test(request.url)) {
    const translationRequest = request.clone({
      url: request.url
    });
    return next(translationRequest);
  }

  const excludedUrlPattern = /^\/selfcare\/vehicles\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/documents$/;;
  const excludedDriversUrlPattern = /^\/selfcare\/drivers\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/documents\/$/;
  const excludedProofOfPaymentUrl = /^\/selfcare\/orders\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/pay$/;
  const excludedProfileDocumentsUrl = /^\/selfcare\/profile\/documents/;
  const shouldAddContentTypeHeader: boolean = excludedUrlPattern.test(request.url) || excludedDriversUrlPattern.test(request.url) ||
    excludedProofOfPaymentUrl.test(request.url) || excludedProfileDocumentsUrl.test(request.url);


  if (!shouldAddContentTypeHeader) {
    headers = headers.append('Content-Type', 'application/json');
  }

  const requestWithCustomHeader = request.clone({
    url: `${environment.apiUrl}${request.url}`,
    headers: headers,
  });

  return next(requestWithCustomHeader);
};
